export enum PricingMatrixUnitType {
    Price,
    Each,
    Amount,
    Percentage
}